import React from 'react';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';

interface Props {
  onDiscard(): void;
  onCancel(): void;
}

export const UnsavedChangesModal: React.FC<Props> = ({ onDiscard, onCancel }) => {
  return (
    <Modal isOpen onRequestClose={onCancel}>
      <ModalHeader variant="warning">Discard Unsaved Changes</ModalHeader>

      <ModalBody>
        Changes will be lost if you leave this page or close the tab without saving.
      </ModalBody>

      <ModalFooter>
        <Button variant="errorSecondary" onClick={onDiscard} mr="8">
          Leave & Discard Changes
        </Button>

        <Button onClick={onCancel}>Keep Editing</Button>
      </ModalFooter>
    </Modal>
  );
};
